import React from "react";
import styled from "styled-components/native";
import { Spacer, VDBText } from "@components/atoms";
import { SpaceType } from "@components/atoms/Spacer/types";
import { useTheme } from "styled-components/native";
import { useTranslation } from "react-i18next";
import CollapsibleView from "@components/molecules/CollapsibleView";
import LineViewContainer from "./utils/LineView";
import CommentBodySection from "./utils/CommentBodySection";
import { getRequestType } from "./utils/utils";
import { getBoxShadow } from "@utils/product/productValidators";
import { useTypographyStore } from "@redux/slices/typographySlice";

interface CommentSectionProps {
  requestType: string;
  comments: string;
}

const CommentSection = ({ requestType, comments }: CommentSectionProps) => {
  const theme = useTheme();
  const { t } = useTranslation();
  const typography = useTypographyStore();

  return (
    <>
      <CardContainer>
        <CollapsibleView
          initExpanded={true}
          applyTopPadding={false}
          arrowStyling={{ color: theme["core-04"] }}
          title={
            getRequestType(requestType) === "Questions"
              ? t("requestHistoryDetail.questions.text")
              : t("requestHistoryDetail.comments.text")
          }
        >
          <LineViewContainer />
          <CommentBodySection>
            <VDBText color={theme["core-06"]} type={typography["Body-R"]}>
              {comments || "-"}
            </VDBText>
          </CommentBodySection>
        </CollapsibleView>
      </CardContainer>
      <Spacer size={SpaceType.Double} />
    </>
  );
};

const CardContainer = styled.View`
  background-color: ${({ theme }) => theme["core-01"]};
  border-radius: 8px;
  border: 1px solid ${({ theme }) => theme["core-03"]};
  box-shadow: ${({ theme }) => getBoxShadow(theme.Shadows.Gentle)};
`;

export default CommentSection;
